import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import "./LoginMessage.css";

const LoginMessage = () => {
  return (
    <div className="login-message-container">
      <div className="login-message-card">
        <h2>Login to Access Our Services</h2>
        <p>Please log in to your account to view this content and access your full enterprise portal.</p>
        <Link to="/my-account" className="login-btn">
          <span>Go to My Account</span>
          <FiArrowRight className="login-btn-arrow" />
        </Link>
      </div>
    </div>
  );
};

export default LoginMessage;
